module.exports = __webpack_public_path__ + "static/media/petite.a6614692.jpg";